import type React from 'react';
import {
  usePaywallModalsStore,
  type SetActivePaywallModal,
} from '../stores/modal-store';

type UseOpenModalPaywallReturn = SetActivePaywallModal;

export function useOpenModalPaywall(): UseOpenModalPaywallReturn {
  return usePaywallModalsStore((state) => state.setActivePaywallModal);
}

type UseCloseModalPaywallReturn = () => void;

export function useCloseModalPaywall(): UseCloseModalPaywallReturn {
  return usePaywallModalsStore((state) => state.closePaywallModal);
}

interface UseActivePaywallModalReturn {
  activePaywallModalContent: React.JSX.Element | null;
  open: boolean;
}

export function useActivePaywallModal(): UseActivePaywallModalReturn {
  return usePaywallModalsStore((state) => ({
    activePaywallModalContent: state.activePaywallModalContent,
    open: state.open,
  }));
}
